import { useTerritoriosStore } from "@/store/territorios";
import { useTrabajoStore } from "@/store/useTrabajoStore";
import { useRutasStore } from "@/page/rutas/useRutasStore";

const url = location.origin;

export const useMapData = () => {
  const territorios = useTerritoriosStore()
  const trabajo = useTrabajoStore()
  const rutas = useRutasStore()

  const getArrayItem = (item) => {
    let routes = []
    if (item.tipo === 'routes') {
      for (let i in item.routes) {
        const ruta = rutas.list.find(r => r.id === item.routes[i])
        if (ruta) routes.push(ruta)
      }
    }
    const { numero, center, color, angle, zoom, mzNumbers, referencia, limits, notas, pendiente, tipo } = item
    const zona = item.zona || "-"
    return [numero, zona, center, [color.backgroundColor, color.color], angle, zoom, mzNumbers, referencia, limits, notas, pendiente, tipo, routes]
  }

  const getMapData = (terrAsignados) => {
    const items = []
    for (let i in terrAsignados) {
      const terr = terrAsignados[i]
      const item = { ...territorios.data[terr] }
      if (item && trabajo.data[terr]) {
        item.pendiente = trabajo.data[terr].manzanasPendientes
        delete item.puntoEncuentro
        delete item.uuid
        items.push(getArrayItem(item))
      }
    }
    return items
  }

  const getItemUrl = (item, pendiente) => {
    const itemUrl = JSON.parse(JSON.stringify(item))
    delete itemUrl.puntoEncuentro
    delete itemUrl.uuid
    if (pendiente) itemUrl.pendiente = pendiente
    return `${url}/map?items=${encodeURIComponent(JSON.stringify([getArrayItem(itemUrl)]))}`
  }

  return { getMapData, getArrayItem, getItemUrl }
}
